import { Button } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { Icon } from '@/components/custom-icon'
import useUrlControl from '@/components/public-page/hook/use-url-control'
import { Page } from '@/hooks/use-authorization/constants'
import { useI18n } from '@/hooks/use-i18n'
import { useIntl } from '@/i18n/hooks/use-intl'
import { ampli } from '@/utils/ampli'

const Blocker: FunctionComponent = () => {
  const { formatMessage } = useIntl()
  const router = useRouter()
  const { locale } = useI18n()
  const { getAppUrl } = useUrlControl()

  return (
    <Wrapper>
      <Icon
        style={{
          fontSize: '24px',
          justifyContent: 'center',
        }}
        type='featherLock'
      />
      <Text>
        {formatMessage({ id: 'account:apply_for_professional_trial' })}
      </Text>
      (
      <Link
        href={getAppUrl(Page.Register, { from: 'public search', lang: locale })}
        onClick={(): void => {
          ampli.clicksRegister({
            from: 'public search',
            path: router.asPath,
          })
        }}
      >
        <Button type='primary'>
          {formatMessage({ id: 'account:register_submit_btn' })}
        </Button>
      </Link>
      )
    </Wrapper>
  )
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  backdrop-filter: blur(3px);

  .anticon {
    svg {
      fill: none;
      stroke: ${({ theme }): string => theme.colors.gray10};
    }
  }
`

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.gray10};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 32px;
  margin: 5px 0 10px;
`

export default Blocker
